module.exports = __webpack_public_path__ + "static/beachHouse-5ec6d890e44c0d7a69f85da0a36e2109.jpg";